import {
  getSectionCanCreatePermission,
  getSectionCanViewPermission,
} from '../../utils/common'
import { useInitData } from '../useInitData'

export function useSectionPermissions({ sectionName }) {
  const { sections } = useInitData()

  return {
    canCreate: getSectionCanCreatePermission(sections, sectionName),
    canView: getSectionCanViewPermission(sections, sectionName),
  }
}
